import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType, getEveryDayDateStringList } from '@/utils/date'

export const drawStationSpendingehart = (chart: ECharts, data: any, filter: any) => {
  let xAxisData = []
  let mapper:any = {
    0: '余额消费',
    1: '微信消费',
    2: '卡片消费'
  }
  let legend:any = {}
  let balanceData:any = []
  let cardData:any = []
  let wepayData:any = []

  let showBalance = false
  let showCard = false
  let showWepay = false

  for (let item of data) {
    legend[mapper[item.paytype]] = 0
    let value = parseFloat(parseFloat(item.total).toFixed(2))
    if (item.paytype === 0) {
      balanceData.push(value)
      cardData.push(0)
      wepayData.push(0)
      showBalance = true
    } else if (item.paytype === 2) {
      cardData.push(value)
      wepayData.push(0)
      balanceData.push(0)
      showCard = true
    } else if (item.paytype === 1) {
      wepayData.push(value)
      balanceData.push(0)
      cardData.push(0)
      showWepay = true
    }
    let date = new Date(item.date)
    xAxisData.push(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`)
  }
  let seriesData:any = []
  if (showBalance) {
    seriesData.push({
      name: '余额消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: balanceData
    })
  }
  if (showCard) {
    seriesData.push({
      name: '卡片消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: cardData
    })
  }
  if (showWepay) {
    seriesData.push({
      name: '微信消费',
      type: 'line',
      markLine: {
        data: [{ type: 'average', name: '平均值' }]
      },
      data: wepayData
    })
  }

  chart.setOption({
    title: {
      text: `气站消费数据(${getTitleStringByType(filter)})`
    },
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}￥'
    },
    xAxis: {
      data: xAxisData
    },
    yAxis: {},
    legend: {
      data: legend.keys
    },
    series: seriesData
  })
}
